import type { ReactNode } from 'react';

interface SectionCardProps {
  title: string;
  description?: string;
  icon?: string;
  children: ReactNode;
}

export default function SectionCard({ title, description, icon, children }: SectionCardProps) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-start gap-3">
        {icon && (
          <div className="w-10 h-10 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
            <i className={`${icon} text-lg`} />
          </div>
        )}
        <div className="min-w-0">
          <h3 className="font-heading font-semibold text-foreground-950">{title}</h3>
          {description && (
            <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{description}</p>
          )}
        </div>
      </div>
      <div className="mt-5 space-y-5">{children}</div>
    </section>
  );
}